wbApp.factory('activeFeaturesSvc', ['localStorageService', 'formSvc',
    function (localStorageService, formSvc) {




        function isClientFormSupportEnabled(remoteFetchDoneFn) {

            if (localStorageService.isSupported) {

                var lastCheck = localStorageService.get('isClientFormSupportEnabled-lastCheck');
                if (!!lastCheck) {
                    lastCheck = moment(lastCheck, moment.ISO_8601);
                    if (!lastCheck.isValid() || lastCheck.isBefore(moment().subtract(5, 'm'))) {
                        lastCheck = null;
                    }
                }

                var result = localStorageService.get('isClientFormSupportEnabled') == 'true';


                if (!lastCheck) {
                    formSvc.getAllActive().then(function (data) {
                        var shouldBeActive = !!data && data.length > 0;
                        localStorageService.set('isClientFormSupportEnabled', shouldBeActive);
                        localStorageService.set('isClientFormSupportEnabled-lastCheck', moment().format());

                        if (!!remoteFetchDoneFn) {
                            remoteFetchDoneFn(shouldBeActive);
                        }
                    });
                } else {
                    if (!!remoteFetchDoneFn) {
                        remoteFetchDoneFn(result);
                    }
                }

                return result;
            }

            return true;
        }

        return {
            isClientFormSupportEnabled: isClientFormSupportEnabled
        }
    }
]);
